/** @jsxImportSource @emotion/react */

import { RosterProvider } from './context/RosterContext'
import { UIProvider } from './context/UIContext'
import UnifiedRosterPage from './UnifiedRosterPage'

interface UnifiedRosterProps {
  teamId: string
  teamName: string
  permission: Record<string, any>
  refreshKey?: number
  pendingHighlightId?: string | null
  onPendingHighlightConsumed?: () => void
  onActiveTabChange?: (tab: 'players' | 'officials') => void
  onComplete: (data: any) => void
  existingRosterIdFromLocationState?: string
  isSoccer?: boolean
  sportName?: string
  sportId?: string
}

const UnifiedRoster = ({
  teamId,
  teamName,
  permission,
  refreshKey,
  pendingHighlightId,
  onPendingHighlightConsumed,
  onActiveTabChange,
  onComplete,
  existingRosterIdFromLocationState,
  isSoccer,
  sportName,
  sportId,
}: UnifiedRosterProps) => {
  return (
    <RosterProvider
      teamId={teamId}
      onComplete={onComplete}
      existingRosterIdFromLocationState={existingRosterIdFromLocationState}
      refreshKey={refreshKey}
    >
      <UIProvider>
        <UnifiedRosterPage
          teamId={teamId}
          teamName={teamName}
          permission={permission}
          pendingHighlightId={pendingHighlightId}
          onPendingHighlightConsumed={onPendingHighlightConsumed}
          onActiveTabChange={onActiveTabChange}
          isSoccer={isSoccer}
          sportName={sportName}
          sportId={sportId}
        />
      </UIProvider>
    </RosterProvider>
  )
}

export default UnifiedRoster
